import { MLHelper } from '@bimser/core';
import { iconTextRenderer } from '../iconTextRenderer';

export function EditCellItemComponent(props) {
	return iconTextRenderer(MLHelper.getMLText(props.data.text), props.data.icon);
}
